import { CbsOverzicht } from '../types';
import { Get } from './helpers/builder';

export const getCbsOverzicht = Get`/lists/providers/${'provider'}/cbs?van=${'van'}&tot=${'tot'}`.json<{ response: CbsOverzicht[] }>();
